import React from 'react';
import PropTypes from 'prop-types';
import Breakpoints from 'react-breakpoints';

import NavigationDropdownWrapper from './navigation_dropdown_wrapper';

const breakpoints = {
  mobile: 768,
  desktop: 769,
};

// need to wrap in breakpoint to detect mobile
const NavigationDropdownBreakPoints = (props) => (
  <Breakpoints breakpoints={breakpoints}>
    <NavigationDropdownWrapper {...props} />
  </Breakpoints>
);

NavigationDropdownBreakPoints.defaultProps = {
  libraryName: "Brandfolder",
};

NavigationDropdownBreakPoints.propTypes = {
  brandguideDomain: PropTypes.string.isRequired,
  libraryName: PropTypes.string,
  rootDomain: PropTypes.string.isRequired,
};

export default NavigationDropdownBreakPoints;
